<div
  class="content-row"
  [class]="'content-row--' + (iconColor() || 'default')"
  [class.content-row--danger]="tone() === 'danger'"
  [class.content-row--selector]="variant() === 'selector'"
  [class.content-row--round]="avatarShape() === 'round'"
>
  <ng-content select="[leading]" />
  @if (fileName()) {
    <aw-file-icon size="row" aria-hidden="true" [name]="fileName()" />
  } @else if (emoji()) {
    <span class="content-row__emoji" aria-hidden="true">{{ emoji() }}</span>
  } @else if (visibleImage()) {
    <img class="content-row__image" alt="" [src]="visibleImage()" (error)="onImageError()" />
  } @else if (initials()) {
    <span class="content-row__initials" aria-hidden="true" [class]="'content-row__initials--' + initialsColor()">{{
      initials()
    }}</span>
  } @else if (icon()) {
    <i
      class="aw-2-icn content-row__icon"
      aria-hidden="true"
      [class.content-row__icon--badge]="iconBadge()"
      [awIcon]="icon()"
    ></i>
  }
  <div class="content-row__body"><ng-content /></div>
  <div class="content-row__trailing"><ng-content select="[trailing]" /></div>
</div>
